// extracted by mini-css-extract-plugin
export default {"tabListItem":"tab-module__tabListItem__KXJmc","active":"tab-module__active__qwkeq"};